export default __webpack_public_path__ + "static/media/one-time-setup-360devpro.65c2f01c.svg";